import app from './app/reducer';

export default {
  app,
}